<failure-wrapper>
  <main class="reports">
    <header class="reports__tabs">
      <cds-tab
        [label]="'Demonstrativo Financeiro Mensal'"
        [checked]="isSelectedTab('monthly')"
        (click)="setSelectedTab('monthly')"
      />
      <cds-tab
        [label]="'Comparativo de Resultados'"
        [checked]="isSelectedTab('comparative')"
        (click)="setSelectedTab('comparative')"
      />
    </header>

    <!-- Demonstrativo Financeiro Mensal -->
    @if (isSelectedTab('monthly')) {
      <bfm-monthly
        [monthlyAnalysisLabel]="'Relatório DFM | Demonstrativo Financeiro Mensal'"
        [resultsTabLabel]="'DFM por Resultados'"
        [chartAccountsTabLabel]="'DFM por Categorias'"
      />
    }
    <!-- ! Demonstrativo Financeiro Mensal -->

    <!-- Comparativo de Resultados -->
    @if (isSelectedTab('comparative')) {
      <bfm-monthly-comparative />
    }
    <!-- ! Comparativo de Resultados -->
  </main>
</failure-wrapper>
